import { useContext, useState as classicUseState } from 'react';
import { Icon as BlueIcon } from '@blueprintjs/core';
import { CSSTransition } from 'react-transition-group';
import { ClickAwayListener } from '@material-ui/core';
import { useNavigationState } from '@store/hookstate';

import { CreateUpdateContext } from '@components/CreateUpdatesDialog/CreateUpdatesDialog.query';
import { MenuContent } from './components';

import {
  Container,
  Block,
  ContainerSidebar,
  MenuText,
  FakeInputDiv,
  IconDiv,
} from './Menu.styles';

const Menu = () => {
  const [open, setOpen] = classicUseState(false);
  const navigationState = useNavigationState();
  const handleClickAway = () => {
    setOpen(false);
  };

  const { selectedMenufacturers } = useContext(CreateUpdateContext);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ContainerSidebar onClick={() => setOpen(!open)}>
          <FakeInputDiv open={open}>
            <MenuText isPlaceholder={selectedMenufacturers.length <= 0}>
              {selectedMenufacturers.length > 0
                ? selectedMenufacturers.map(item => item.name)
                : 'Select a Manufacturer'}
            </MenuText>
            {open ? (
              <IconDiv>
                <BlueIcon icon="chevron-up" color="#8F95B2" />
              </IconDiv>
            ) : (
              <IconDiv>
                <BlueIcon icon="chevron-down" color="#8F95B2" />
              </IconDiv>
            )}
          </FakeInputDiv>
        </ContainerSidebar>

        <CSSTransition
          in={open}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => setOpen(true)}
          onExited={() => setOpen(false)}
        >
          <Block
            width={
              navigationState.sidebarOpen.get()
                ? navigationState.maxLeft.get()
                : navigationState.minLeft.get()
            }
          >
            <MenuContent setOpen={setOpen} />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { Menu };
